<template>
  <div class="flex-col items-center space-y-3 my-6 px-6">
    <p class="text-center">
      Granfield is a technology company focusing on financial education.
    </p>
  </div>
</template>
